var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.1101,
    y: 16.7451,
    width: 6,
    height: 6,
    rx: 3,
    transform: "rotate(90 25.1101 16.7451)",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C26.4127 11 30 14.4889 30 18.7732C30 24.5218 24.4701 30.5776 22 33C19.5299 30.5776 14 24.5218 14 18.7732C14 14.4889 17.5873 11 22 11Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSites);
export default __webpack_public_path__ + "static/media/btn_sites.813a92c370290f8cb4ab1e4a6ffc8881.svg";
export { ForwardRef as ReactComponent };